import React from 'react'
import { Item, Button, Confirm, Popup, Segment, Label } from 'semantic-ui-react'
import { selectMatch, selectQuestionsCount, deleteMatch } from '../reducers/matches';
import { editMatch } from '../reducers/editMatchId';
import { connect } from 'react-redux';
import fixModalStyle from '../utils/fixModalStyle'
import { formatDate } from '../utils/formatDate'

class MatchItem extends React.Component {
    state = { confirmOpen: false }

    onDeleteClick = () => this.setState({ confirmOpen: true })
    onCloseConfirm = () => this.setState({ confirmOpen: false })
    onConfirmDelete = () => {
        const { match, onDeleteClick } = this.props
        onDeleteClick(match)
        this.setState({ confirmOpen: false })
    }

    renderRunningLabel = (starting_time, ending_time) => {
        if (ending_time)
            return <Label>Andata in onda il {formatDate(starting_time)}</Label>
        if (starting_time)
            return <Label color='green'>In onda</Label>
    }

    render() {
        const { match, index, questionsCount, onEditClick } = this.props
        const { confirmOpen } = this.state
        const { deleting, starting_time, ending_time } = match
        const title = 'Puntata ' + (index + 1)

        return (
            <Segment>
                <Item>
                    <Confirm style={fixModalStyle}
                        open={confirmOpen} 
                        header='Conferma cancellazione' 
                        content={'Sicuro di voler cancellare ' + title + '?'}
                        onClose={this.onCloseConfirm}
                        onCancel={this.onCloseConfirm}
                        onConfirm={this.onConfirmDelete} />
                    <Item.Content>
                        <Item.Header>
                            {deleting ? 'In cancellazione ' : ''} {title} ({questionsCount} / 5 domande) {this.renderRunningLabel(starting_time, ending_time)}
                        </Item.Header>
                        <Item.Description>
                            <Button.Group>
                                <Popup trigger={<Button icon='edit' onClick={onEditClick} />} content='Modifica' />
                                <Popup trigger={<Button icon='trash' onClick={this.onDeleteClick} />} content='Elimina' />
                            </Button.Group>
                        </Item.Description>
                    </Item.Content>
                </Item>
            </Segment>
        )
    }
}


const mapStateToProps = (state, { game_id }) => ({
    match: selectMatch(state, game_id),
    questionsCount: selectQuestionsCount(state, game_id)
})

const mapDispatchToProps = (dispatch, { socket, game_id }) => ({
    onEditClick: () => dispatch(editMatch(game_id)),
    onDeleteClick: () => dispatch(deleteMatch(socket, game_id)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MatchItem)


// WEBPACK FOOTER //
// ./src/components/MatchesListItem.js